import { Color } from '@pixi/color';
import { Container, Graphics } from 'pixi.js-legacy';

import { themingInstance } from '@exchange/libs/utils/theming/src';

import TextValue from './pixi-text-value';

export default class SizeLine extends Container {
  public label: TextValue;

  private graphics = new Graphics();

  private dividerDot = new Graphics();

  private color: string | undefined;

  private isAsk = true;

  private sideHeight = 0;

  private get colorHex() {
    return new Color(this.color ?? themingInstance.getColor(this.isAsk ? '--v-theme-error' : '--v-theme-success')).toNumber();
  }

  constructor({ lineX, lineY, isAsk, sideHeight, fontName }: { lineX: number; lineY: number; isAsk: boolean; fontName: string; sideHeight: number }) {
    super();
    this.x = lineX;
    this.y = lineY;

    this.isAsk = isAsk;
    this.sideHeight = sideHeight;

    this.label = new TextValue({ fontName, text: '' });
    this.label.x = -this.label.width - 10; // move text 10px to the left

    this.draw();
    this.addChild(this.label, this.graphics, this.dividerDot);
  }

  public update(x: number, percent: number, y: number) {
    const calculatedY = (this.sideHeight - y) / 2 - this.label.textHeight / 2;
    const sign = this.isAsk ? '+' : '-';

    this.label.text = `${sign}${percent.toFixed(2)}%`;
    this.label.y = calculatedY;
    this.label.x = -this.label.width - 10; // move text 10px to the left
    this.x = x - 1; // -1px offset so the pattern aligns with the chart
    this.dividerDot.y = this.sideHeight - y;
  }

  private draw() {
    this.graphics.beginFill(this.colorHex);
    this.graphics.drawCircle(1, 0, 2); // starting dot on the graph

    if (this.isAsk) {
      // handle direction where pattern is going & generate pattern
      for (let i = 0; i < 200; i += 1) {
        this.graphics.drawRect(1, i * 4, 1, 3);
      }
    } else {
      for (let i = 0; i < 200; i += 1) {
        this.graphics.drawRect(0, -i * 4, 1, 3);
      }
    }

    this.graphics.endFill();

    this.dividerDot.beginFill(this.colorHex);
    this.dividerDot.drawCircle(1, 1, 2); // ending dot on the middle divider line
    this.dividerDot.endFill();
  }
}
